import { render, staticRenderFns } from "./rotator.config.vue?vue&type=template&id=440ac978"
import script from "./rotator.config.vue?vue&type=script&lang=js"
export * from "./rotator.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports